import { memo } from "react";
import { Stack } from "@chakra-ui/react";
import { NodeProps } from "reactflow";
import { useUpdateNodeData } from "../../../hooks/useUpdateNodeData";
import { NodeData, NodeType } from "../../../models/nodeType";
import { InputError } from "../../base/InputError";
import SelectMapEntity from "../../base/SelectMapEntity";
import BaseNode from "../../../features/reactflow/nodes/base/BaseNode";

export interface MapEntity extends NodeData {
  stableFeatureId: string;
  worldId: string;
}

function MapEntityNode(props: NodeProps<NodeType<MapEntity>>) {
  const {
    id: nodeId,
    data: { color, nodeData },
  } = props;

  const { updateNodeData } = useUpdateNodeData<MapEntity>(nodeId);

  const stableFeatureId = nodeData?.stableFeatureId;

  return (
    <BaseNode {...props}>
      <Stack p={2}>
        <SelectMapEntity color={color} value={nodeData} setValue={updateNodeData} />

        {!stableFeatureId && <InputError errorMessage="Please select an entity" />}
      </Stack>
    </BaseNode>
  );
}

export default memo(MapEntityNode);
